import Vue from "vue";
import App from "./App.vue";
import VueScrollactive from "vue-scrollactive";

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -85,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(VueScrollactive);

import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);

import Meta from "vue-meta";
Vue.use(Meta);

import "@/assets/css/main.css";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
